module.exports = __webpack_public_path__ + "static/media/paper.3fd66b69.svg";